/**
 * Os rótulos das tarefas de classificação, em um lugar só.
 *
 * Existiam duplicados em `SettingsPage` e `MentionAiTrace`, e a terceira
 * cópia — escrita para a tela de Modelos de IA — nasceu com três chaves
 * ERRADAS (`theme` por `themes`, `approach` e `summary`, que não
 * existem). O sintoma foi mudo, que é o de sempre nesse padrão: a tabela
 * mostrou `themes`, `group_themes` e `citation_in_title` crus, sem erro
 * nenhum, e só apareceu porque a tela foi aberta.
 *
 * As chaves são os valores de `core.vocabulary.PROMPT_TASKS`. Tarefa
 * desconhecida cai no próprio identificador — preferível a sumir da
 * lista.
 */
export const PROMPT_TASK_LABELS: Record<string, string> = {
  polarity: "Polaridade",
  intensity: "Intensidade",
  polarity_intensity: "Polaridade e intensidade",
  themes: "Subtemas",
  group_themes: "Temas",
  role: "Papel da marca (abordagem)",
  key_message: "Mensagem-chave",
  citation_in_title: "Citação no título",
  spokesperson: "Porta-voz"
};

export function promptTaskLabel(task: string): string {
  return PROMPT_TASK_LABELS[task] ?? task;
}
